export type FilesMockSaveMode = 'on-send' | 'ask';

export function filesMockMode(): FilesMockSaveMode | null {
  if (!import.meta.env.DEV) return null;
  const value = import.meta.env.VITE_AI_CIO_FILES_MOCK;
  if (value === 'on-send' || value === 'true') return 'on-send';
  if (value === 'ask') return 'ask';
  return null;
}
